import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import styles from './inputWithButton.module.css';

interface InputWithButtonProps {
  inputPlaceholder?: string;
  inputValue: string;
  hideButton?: boolean;
  buttonText?: string;
  buttonColor?: string;
  buttonStyle?: keyof typeof ColorStyle | undefined;
  onClickButton?: () => void;
  readOnly?: boolean;
}

export const InputWithButton = ({
  inputPlaceholder,
  inputValue,
  buttonText,
  buttonColor,
  buttonStyle,
  hideButton,
  onClickButton,
  readOnly,
}: InputWithButtonProps) => {
  return (
    <div className={styles.inputWithbutton}>
      <input
        id={`input-with-button-${buttonText}`}
        name="input-with-button"
        type="text"
        value={inputValue}
        placeholder={inputPlaceholder}
        readOnly={readOnly}
      />

      {!hideButton && (
        <div className={styles.button}>
          <RoundedButton
            colorOverride={buttonColor}
            colorStyle={buttonStyle}
            onClick={() => onClickButton && onClickButton()}
          >
            {buttonText}
          </RoundedButton>
        </div>
      )}
    </div>
  );
};

export default InputWithButton;
